// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img_size_mobile[data-v-8e7797c8]{width:170px;height:170px}.img_size_desktop[data-v-8e7797c8]{width:220px;height:220px}.descriptionElement[data-v-8e7797c8]{height:70px;overflow:hidden}.element_width[data-v-8e7797c8]{width:220px;overflow:hidden}.element_width_mobile[data-v-8e7797c8]{width:170px}.hoveredElement[data-v-8e7797c8]{background-color:#f0f0f0;border:1px solid #e2001a}.notHoveredElement[data-v-8e7797c8]{margin:1px}", ""]);
// Exports
module.exports = exports;
